import { render, staticRenderFns } from "./ModalChannelSkill.vue?vue&type=template&id=80b36976&lang=pug&"
import script from "./ModalChannelSkill.vue?vue&type=script&lang=js&"
export * from "./ModalChannelSkill.vue?vue&type=script&lang=js&"
import style0 from "./ModalChannelSkill.vue?vue&type=style&index=0&id=80b36976&prod&lang=sass&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports